import { CancelToken } from 'axios';
import { awApiWithPkg } from './Base';

// https://dev.azure.com/1A4D/Aladdin%20Wealth/_git/aladdin-wealth-server?path=/src/main/java/com/bfm/arm/portfolio/models/holding/HoldingsHistoryRequest.java
type HoldingsTableRequest = {
  pkg?: string;
  analysisDate: string;
  benchType: string;
  accountID?: string | null;
  monthsLookback: number;
  calendar: string;
};
export type HoldingsHistorySnapshotResponse = {
  holdingsSnapshots: { date: string; legacyPositions: { identifier: string; weight: number }[] }[];
}[];
export function postHoldingsHistorySnapshots(request: HoldingsTableRequest, cancelToken?: CancelToken) {
  const path = 'holdings/history/snapshots';
  return awApiWithPkg.post<HoldingsHistorySnapshotResponse>(path, request, {
    cancelToken,
  });
}
